import "./loader.css"
const Loader = () => {
    return (
        <div className="flex items-center justify-center">
            <div className="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    )
}

export default Loader
